module.exports = __webpack_public_path__ + "img/logo.363a6d0c.png";